import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/puntcity/images/logo.png';

export default function index() {
  return <Image src={footerLogo} maxW="92px" ml={['0', null, '4']} />;
}
